export default __webpack_public_path__ + "static/media/pen-intro-santa.b1bdb9a7.png";